import { TextareaAutosize, TextareaAutosizeProps, useTheme } from '@mui/material';

function Textarea(props: TextareaAutosizeProps) {
  const theme = useTheme();

  return (
    <TextareaAutosize
      {...props}
      style={{
        resize: 'none',
        outline: 'none',
        width: '100%',
        color: theme.palette.text.primary,
        fontFamily: theme.typography.fontFamily,
        fontSize: theme.typography.body1.fontSize,
        padding: theme.spacing(1.5),
        borderRadius: theme.spacing(0.5),
        borderColor: theme.palette.grey['100'],
      }}
    />
  );
}

export default Textarea;
